import { useState } from 'react';
import { Upload, X } from 'lucide-react';

const ACCEPT = '.pdf,.docx,.md,.txt';
const MAX_BYTES = 10 * 1024 * 1024;

export default function UploadFileModal({ onClose, onUpload }) {
  const [file, setFile] = useState(null);
  const [name, setName] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const onFileChange = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (f.size > MAX_BYTES) {
      setError('File too large (max 10 MB).');
      return;
    }
    setError(null);
    setFile(f);
    if (!name) setName(f.name);
  };

  const onSubmit = async () => {
    if (!file) { setError('Choose a file.'); return; }
    setBusy(true);
    setError(null);
    try {
      await onUpload(file, name || file.name);
      onClose();
    } catch (err) {
      setError(err?.response?.data?.detail || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="card-title">Upload a file</div>
          <button className="icon-btn" onClick={onClose} aria-label="Close"><X size={16} /></button>
        </div>
        <label className="file-drop">
          <Upload size={20} />
          {file ? file.name : 'Drop a PDF, DOCX, MD or TXT — or click to pick'}
          <input type="file" accept={ACCEPT} onChange={onFileChange} style={{ display: 'none' }} />
        </label>
        <input
          className="step-subject"
          value={name}
          placeholder="Display name"
          onChange={(e) => setName(e.target.value)}
        />
        {error && <div className="card-row error-text">{error}</div>}
        <div className="card-actions">
          <button className="primary-btn" onClick={onSubmit} disabled={busy || !file}>
            {busy ? 'Uploading…' : 'Upload'}
          </button>
          <button className="text-btn" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
